import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "openservice-mean-time-between-failures",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,
    max: 1,
    types: ["Boolean"],
  },

  presets: [
    {
      label: "highcharts:explorer.mtbf.title",
      description: "highcharts:explorer.mtbf.description",
      tags: ["kpi"],
      imageLink:"",
      widget: {
        config: {
          icon: "fa:info",
        },
      },
    },
  ],
});
